import type { ImageType } from '@eliadmin/core/src/api/api-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';

import { CmsIcon } from './cms-image';

export type Benefit = { id: number; name: string; icon: ImageType | null };

/** Trust badges (section „Výhody“) separated by dots — hero and mega menu. */
export function Benefits({ items, className }: { items: Benefit[]; className?: string }) {
  if (!items.length) return null;

  return (
    <ul className={cn('flex flex-wrap items-center gap-2', className)}>
      {items.map((item, index) => (
        <li key={item.id} className="flex items-center gap-2">
          <CmsIcon image={item.icon} className="size-5" />
          <span className="svt-benefit whitespace-nowrap text-[#14171a]">{item.name}</span>
          {/* Separator after the item, so a wrapped row ends with the dot (Figma order). */}
          {index < items.length - 1 ? (
            <span aria-hidden="true" className="size-1 shrink-0 rounded-full bg-[#c9cdc4]" />
          ) : null}
        </li>
      ))}
    </ul>
  );
}
